import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import PPIFormComponent from './ppi-form-component';
import * as actions from '../../../actions';
import PPIService from '../../../service/sfp/ppi-service';

class PPIFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: undefined,
			submitting: false
		};
	}

	render() {
		return (
			this.props.scenario
				?
				<PPIFormComponent
					onSubmit   = {this._handleSubmit}
					submitting = {this.state.submitting}
				/>
				:
				<div>Aucun scénario n'est validé pour l'année en cours.</div>
		)
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true })

		const ppi = {
			prospLength: event.target.prospLength.value,
			fctva: event.target.fctva.value,
			fctvaRetrieve: event.target.fctvaRetrieve.value,
			thirdParties: event.target.thirdParties.value,
			localAuthority: this.props.localAuthority.id
		}

		PPIService.createPPI(ppi, this.props.localAuthority.id)
			.then(this._resolveCreatePPI.bind(this, event), this._rejectCreatePPI)
	}

	_rejectCreatePPI = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveCreatePPI = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()

		this.setState({ submitting: false }, () => {
			this.props.onCreated(response)
		})
	}


}

const mapDispatchToProps = dispatch => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(null, mapDispatchToProps)(PPIFormContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-form/ppi-form-container.js